module.exports = __webpack_public_path__ + "static/media/蓝牙写卡_lg.cabb7533.jpg";